import coverImg from '../../../assets/images/literature/the-line-gang-cover.jpg';

const SEGMENTS = [
    {
        id: 'line-gang-1',
        title: 'The Living Thread',
        text: `Here come the line-gang pioneering by,
They throw a forest down less cut than broken.
They plant dead trees for living, and the dead
They string together with a living thread.
They string an instrument against the sky
Wherein words whether beaten out or spoken
Will run as hushed as when they were a thought
But in no hush they string it: they go past
With shouts afar to pull the cable taught,
To hold it hard until they make it fast,
To ease away — they have it. With a laugh,
An oath of towns that set the wild at naught
They bring the telephone and telegraph.`,
        morseText: '| | | HERE COME THE LINE GANG PIONEERING BY THEY THROW A FOREST DOWN LESS CUT THAN BROKEN BK THEY PLANT DEAD TREES FOR LIVING AND THE DEAD THEY STRING TOGETHER WITH A LIVING THREAD BK THEY STRING AN INSTRUMENT AGAINST THE SKY WHEREIN WORDS WHETHER BEATEN OUT OR SPOKEN WILL RUN AS HUSHED AS WHEN THEY WERE A THOUGHT BK BUT IN NO HUSH THEY STRING IT THEY GO PAST WITH SHOUTS AFAR TO PULL THE CABLE TAUGHT TO HOLD IT HARD UNTIL THEY MAKE IT FAST BK TO EASE AWAY THEY HAVE IT BK WITH A LAUGH AN OATH OF TOWNS THAT SET THE WILD AT NAUGHT THEY BRING THE TELEPHONE AND TELEGRAPH BK',
        estimatedSeconds: { wpm15: 110, wpm20: 82, wpm25: 66 },
        questions: [
            {
                id: 'line-gang-q1',
                question: 'What do the line-gang plant for "living"?',
                options: ['FLOWERS', 'DEAD TREES', 'VINES', 'SEEDS'],
                answer: 'DEAD TREES',
                difficulty: 'Intermediate'
            },
            {
                id: 'line-gang-q2',
                question: 'What do they bring to the wild at the end?',
                options: ['FOOD AND WATER', 'FIRE AND AXES', 'TELEPHONE AND TELEGRAPH', 'ROADS AND BRIDGES'],
                answer: 'TELEPHONE AND TELEGRAPH',
                difficulty: 'Beginner'
            }
        ]
    }
];

export default {
    id: 'poem-the-line-gang',
    type: 'poem',
    title: 'The Line Gang',
    author: 'Robert Frost',
    publicationDate: '1916',
    coverImage: coverImg,
    genres: ['Modernist Poetry', 'Nature', 'Technology', 'Telegraphy', 'Communication'],
    characterLength: SEGMENTS.reduce((acc, s) => acc + s.text.length, 0),
    description: "Robert Frost's evocative poem contrasting the 'dead trees' of telegraph poles with the 'living thread' of communication.",

    text: SEGMENTS.map(s => s.text).join('\n\n'),
    comprehensionQuestions: SEGMENTS.flatMap(s => s.questions),
    segments: SEGMENTS.map(s => ({
        ...s,
        comprehensionQuestions: s.questions.map(q => q.id)
    })),

    metadata: {
        setting: 'The American Wilderness',
        period: 'Early 20th Century (1910s)',
        themes: ['Man vs Nature', 'Communication', 'Modernity', 'Labor'],
        difficulty: 'Beginner',
        estimatedReadingTimeMinutes: 2,
        stanzas: 1
    }
};
